<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>To my young friends:</i></span></p>
<p class="ded1"><span><i>Brenda, Craig, Eric, Jerry</i>,</span></p>
<p class="ded1"><span><i>Jill, John, Lloyd, Michele</i>,</span></p>
<p class="ded1"><span><i>Ronald, Ruby, Sheryl, and Vinita</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?b675c80e